import { TableSortLabel, Typography } from "@material-ui/core";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";

const TableHead = styled.thead`
  background-color: rgba(255, 255, 255, 0.1);
  border-top: 2px solid #3E4345;
  border-bottom: 1px solid #3E4345;
  color: #FFFFFF;
  height: 48px;
`

const Name = styled.td`
  padding-left: 17px;
  cursor: pointer;
`

const Type = styled.td`
  text-align: center;
  vertical-align: middle;
`

const UpdateDate = styled.td`
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  padding-left: 24px;
`

const Plug = styled.td`
`

type PropsType = {
  order: "desc" | "asc";
  orderBy: "description" | "updated_at";
  onRequestSort: (e: any, field: "description" | "updated_at") => void;
};

const ImagesTableHead: FC<PropsType> = ({order, orderBy, onRequestSort}) => {
  const { t } = useTranslation()

  const createSortHandler = (field: "description" | "updated_at") => (event: any) => {
    onRequestSort(event, field);
  };

  return (
    <TableHead>
      <tr>
        <Name onClick={createSortHandler('description')}>
          <TableSortLabel
            active={orderBy === 'description'}
            direction={orderBy === 'description' ? order : "asc"}
          >
            <Typography>{t('imagesPage_Name')}</Typography>
          </TableSortLabel>
        </Name>
        <Type>
          <Typography>{t('imagesPage_Type')}</Typography>
        </Type>
        <UpdateDate onClick={createSortHandler('updated_at')}>
          <TableSortLabel
            active={orderBy === 'updated_at'}
            direction={orderBy === 'updated_at' ? order : "asc"}
          >
            <Typography>{t('imagesPage_Update_date')}</Typography>
          </TableSortLabel>
        </UpdateDate>
        <Plug/>
      </tr>
    </TableHead>
  )
}

export default ImagesTableHead
